import React, { useState, useEffect, forwardRef } from 'react';

//komponen
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Fab from '@mui/material/Fab';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

//gambar
import AddOutlined from '@mui/icons-material/AddOutlined';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import CachedIcon from '@mui/icons-material/Cached';

function Anggota(props, ref) {
    //state
    const [proses, setProses] = useState(false);
    const [tampil_notif, setTampilNotif] = useState(false);
    const [jenis_notif, setJenisNotif] = useState("success");
    const [isi_notif, setIsiNotif] = useState("");
    const [tampil_dialog, setTampilDialog] = useState(false);
    const [data_anggota, setDataAnggota] = useState([]);
    const [pencarian, setPencarian] = useState("");
    const [permintaan, setPermintaan] = useState("Simpan");
    const [id_anggota, setIdAnggota] = useState("");
    const [nik, setNik] = useState("");
    const [nama, setNama] = useState("");
    const [jk, setJk] = useState(1);
    const [username, setUsername] = useState("");
    const [level, setLevel] = useState("U");
    const [data_gl, setDataGl] = useState([]);
    const [id_gl, setIdGl] = useState("");
    const [tampil_dialog_hapus, setTampilDialogHapus] = useState(false);
    const [jumlah_baris] = useState(40);
    const [jumlah_halaman, setJumlahHalaman] = useState(0);
    const [halaman, setHalaman] = useState(1);
    const [tampil_dialog_reset, setTampilDialogReset] = useState(false);

    //fungsi
    useEffect(() => {
        fetch(props.aplikasi + '/anggota/tampil_anggota_limit.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        cari: "",
                        jumlah_baris: 40,
                        halaman: 1
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataAnggota(data.data);
                    setJumlahHalaman(Math.ceil(data.jumlah_data / 40));
                }
                else {
                    setDataAnggota([]);
                    setJumlahHalaman(0);
                }
            })
            .catch(error => {
                setDataAnggota([]);
                setJumlahHalaman(0);
            }
            );

        fetch(props.aplikasi + '/anggota/generate_id_anggota.php',
            {
                method: 'GET',
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setIdAnggota(data.data);
                }
                else {
                    setIdAnggota("");
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
            })
            .catch(error => {
                setIdAnggota("");
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );

        fetch(props.aplikasi + '/anggota/tampil_gl.php',
            {
                method: 'GET',
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataGl(data.data);
                }
                else {
                    setDataGl([]);
                }
            })
            .catch(error => {
                setDataGl([]);
            }
            );
    }, [props.aplikasi]);

    const tutup_notif = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setTampilNotif(false);
    };

    const tampil_anggota = (halaman_baru) => {
        fetch(props.aplikasi + '/anggota/tampil_anggota_limit.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        cari: pencarian,
                        jumlah_baris: jumlah_baris,
                        halaman: halaman_baru
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataAnggota(data.data);
                    setJumlahHalaman(Math.ceil(data.jumlah_data / jumlah_baris));
                }
                else {
                    setDataAnggota([]);
                    setJumlahHalaman(0);
                }
            })
            .catch(error => {
                setDataAnggota([]);
                setJumlahHalaman(0);
            }
            );
    }

    const pindah_halaman = (halaman_baru) => {
        setHalaman(halaman_baru);
        tampil_anggota(halaman_baru);
    }

    const cari = () => {
        setHalaman(1);
        tampil_anggota(1);
    }

    const bersih_input_anggota = () => {
        generate_id_anggota();
        setPermintaan("Simpan");
        setNik("");
        setNama("");
        setJk(1);
        setUsername("");
        setLevel("U");
        setIdGl("");
    }

    const generate_id_anggota = () => {
        fetch(props.aplikasi + '/anggota/generate_id_anggota.php',
            {
                method: 'GET',
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setIdAnggota(data.data);
                }
                else {
                    setIdAnggota("");
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
            })
            .catch(error => {
                setIdAnggota("");
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }

    const reset_password = () => {
        setProses(true);
        fetch(props.aplikasi + '/anggota/reset_password.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_anggota: id_anggota,
                        user: localStorage.getItem("id_anggota")
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    setProses(false);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    setProses(false);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
                setProses(false);
            }
            );
    }

    const simpan = () => {
        if (nik.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("NIK wajib diisi");
            setTampilNotif(true);
            document.getElementById("nik").focus();
            return;
        }

        if (nama.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("Nama anggota wajib diisi");
            setTampilNotif(true);
            document.getElementById("nama").focus();
            return;
        }

        setProses(true);
        fetch(props.aplikasi + '/anggota/simpan_anggota.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        permintaan: permintaan,
                        id_anggota: id_anggota,
                        nik: nik,
                        nama: nama,
                        jk: jk,
                        username: username,
                        level: level,
                        id_gl: id_gl,
                        user: localStorage.getItem("id_anggota")
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    bersih_input_anggota();
                    tampil_anggota(1);
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    document.getElementById("nik").focus();
                    setProses(false);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    document.getElementById("nik").focus();
                    setProses(false);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
                document.getElementById("nik").focus();
                setProses(false);
            }
            );
    }

    const hapus = () => {
        setProses(true);
        fetch(props.aplikasi + '/anggota/hapus_anggota.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_anggota: id_anggota,
                        user: localStorage.getItem("id_anggota")
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    bersih_input_anggota();
                    tampil_anggota(1);
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    setProses(false);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    setProses(false);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
                setProses(false);
            }
            );
    }

    return (
        <div>
            <Snackbar
                open={tampil_notif}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={tutup_notif}
            >
                <Alert
                    severity={jenis_notif}
                    variant="filled"
                    onClose={tutup_notif}
                    sx={{ width: '100%' }}
                >
                    {isi_notif}
                </Alert>
            </Snackbar>

            <Dialog
                open={tampil_dialog_reset}
                onClose={() => setTampilDialogReset(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Konfirmasi Reset Password
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Apakah anda yakin akan mereset password pengguna menjadi sama dengan nama akun?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        loading={proses}
                        onClick={() => setTampilDialogReset(false)}
                        autoFocus
                    >
                        Tidak
                    </LoadingButton>
                    <LoadingButton
                        loading={proses}
                        onClick={() => {
                            setTampilDialogReset(false);
                            setTampilDialog(false);
                            reset_password();
                        }}
                    >
                        Ya
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Box
                sx={{
                    backgroundColor: "#eff0f0",
                    width: "100%",
                    height: "100%"
                }}
            >
                <Fab
                    color="primary"
                    sx={{
                        background: "#37ce9b",
                        border: "#37ce9b",
                        margin: 0,
                        top: "auto",
                        right: 20,
                        bottom: 20,
                        left: "auto",
                        position: "fixed",
                        zIndex: "99"
                    }}
                    onClick={() => {
                        bersih_input_anggota();
                        setTampilDialog(true);
                    }}
                >
                    <AddOutlined />
                </Fab>

                <Card
                    sx={{ padding: "10px" }}
                >
                    <TextField
                        id="input-with-icon-textfield"
                        label="Cari berdasarkan nama anggota"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchOutlined />
                                </InputAdornment>
                            ),
                        }}
                        value={pencarian}
                        onChange={(event) => setPencarian(event.target.value)}
                        onKeyPress={(event) => {
                            if (event.key === "Enter") {
                                cari();
                            }
                        }}
                    />
                </Card>

                <Grid container spacing={1} sx={{ padding: "10px" }}>
                    {data_anggota
                        .map((tampung_produk, index) => {
                            return (
                                <Grid
                                    item xs={12} sm={6} md={4} lg={3} xl={2}
                                    key={index}
                                    onClick={() => {
                                        // bersih_input_anggota();
                                        setIdAnggota(tampung_produk.id_anggota);
                                        setPermintaan("Perbarui");
                                        setNik(tampung_produk.nik);
                                        setNama(tampung_produk.nama);
                                        setJk(parseInt(tampung_produk.jk));
                                        setUsername(tampung_produk.username);
                                        setLevel(tampung_produk.level);
                                        setIdGl(tampung_produk.id_gl);
                                        setTampilDialog(true);
                                    }}
                                >
                                    <Card>
                                        <List>
                                            <ListItem button>
                                                <ListItemText
                                                    primary={
                                                        <Typography variant="body1" noWrap>{tampung_produk.nama}</Typography>
                                                    }
                                                    secondary={
                                                        <Typography variant="subtitle2" noWrap>{tampung_produk.id_anggota}</Typography>
                                                    }
                                                >
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                    </Card>
                                </Grid>
                            );
                        })}
                </Grid>

                <Grid
                    container item xs={12}
                    justifyContent="center"
                    sx={{
                        marginBottom: "10px"
                    }}
                >
                    <Stack spacing={2}>
                        <Pagination
                            color="primary"
                            count={jumlah_halaman}
                            page={halaman}
                            onChange={(event, nomor) => {
                                pindah_halaman(nomor);
                            }}
                        />
                    </Stack>
                </Grid>
            </Box>

            <Dialog
                open={tampil_dialog}
                onClose={() => setTampilDialog(false)}
            >
                <DialogTitle>Input Data Anggota</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Grid container item spacing={1}>
                            <Grid container item>
                                <Grid item xs={12} sm={4} md={3}>
                                    <Typography variant="body2">
                                        ID Anggota
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={8} md={9}>
                                    <TextField
                                        id="id_anggota"
                                        variant="outlined"
                                        size="small"
                                        disabled
                                        fullWidth
                                        end
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position='end'>
                                                    <IconButton
                                                        onClick={() => generate_id_anggota()}
                                                        edge="end"
                                                    >
                                                        <CachedIcon />
                                                    </IconButton>
                                                </InputAdornment>,
                                        }}
                                        value={id_anggota}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={12} sm={4} md={3}>
                                    <Typography variant="body2">
                                        NIK
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={8} md={9}>
                                    <TextField
                                        id="nik"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={nik}
                                        onChange={(event) => setNik(event.target.value)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={12} sm={4} md={3}>
                                    <Typography variant="body2">
                                        Nama
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={8} md={9}>
                                    <TextField
                                        id="nama"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={nama}
                                        onChange={(event) => setNama(event.target.value)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={12} sm={4} md={3}>
                                    <Typography variant="body2">
                                        JK
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={8} md={9}>
                                    <RadioGroup row
                                        value={jk}
                                        onChange={(e) => {
                                            setJk(e.target.value);
                                        }}
                                    >
                                        <FormControlLabel value={1} control={<Radio />} label="Laki-Laki" />
                                        <FormControlLabel value={0} control={<Radio />} label="Perempuan" />
                                    </RadioGroup>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={12} sm={4} md={3}>
                                    <Typography component={"span"} variant="body2">
                                        Username
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={8} md={9}>
                                    <TextField
                                        id="username"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        value={username}
                                        onChange={(event) => setUsername(event.target.value)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={12} sm={4} md={3}>
                                    <Typography component={"span"} variant="body2">
                                        Level Jabatan
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={8} md={9}>
                                    <FormControl size="small" fullWidth>
                                        <Select
                                            id="level"
                                            variant="outlined"
                                            fullWidth
                                            value={level}
                                            onChange={(event) => {
                                                setLevel(event.target.value);

                                                if (event.target.value !== "K") {
                                                    setIdGl("");
                                                }
                                            }}
                                        >
                                            <MenuItem value="U">Umum</MenuItem>
                                            <MenuItem value="K">Kasir</MenuItem>
                                            <MenuItem value="A">Admin</MenuItem>
                                            <MenuItem value="S">Super Admin</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container item
                                style={
                                    level === "K" ? {} : { display: "none" }
                                }
                            >
                                <Grid item xs={12} sm={4} md={3}>
                                    <Typography component={"span"} variant="body2">
                                        General Ledger
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={8} md={9}>
                                    <FormControl size="small" fullWidth>
                                        <Select
                                            id="gl"
                                            variant="outlined"
                                            fullWidth
                                            value={id_gl}
                                            onChange={(event) => setIdGl(event.target.value)}
                                        >
                                            {data_gl.map((data_gl) => {
                                                return (
                                                    <MenuItem key={data_gl.id_gl} value={data_gl.id_gl}>{data_gl.nama}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>                            
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        loadingPosition="start"
                        variant="contained"
                        color="primary"
                        startIcon={<SaveOutlined />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em" }}
                        loading={proses}
                        onClick={() => simpan()}
                    >
                        <Typography variant="body2" noWrap={true}>{permintaan === "Simpan" ? "Simpan" : "Perbarui"}</Typography>
                    </LoadingButton>

                    <LoadingButton
                        loadingPosition="start"
                        variant="contained"
                        color="primary"
                        startIcon={<CachedIcon />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "tomato" }}
                        loading={proses}
                        onClick={() => setTampilDialogReset(true)}
                    >
                        <Typography component={"span"} variant="body2" noWrap={true}>Reset Password</Typography>
                    </LoadingButton>

                    <LoadingButton
                        loadingPosition="start"
                        variant="contained"
                        color="primary"
                        startIcon={<DeleteIcon />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "red" }}
                        loading={proses}
                        onClick={() => setTampilDialogHapus(true)}
                    >
                        <Typography variant="body2" noWrap={true}>Hapus</Typography>
                    </LoadingButton>

                    <LoadingButton
                        loadingPosition="start"
                        variant="contained"
                        color="primary"
                        startIcon={<CloseOutlined />}
                        sx={{ marginTop: "5px", borderRadius: "5em", backgroundColor: "#555555" }}
                        loading={proses}
                        onClick={() => setTampilDialog(false)}
                    >
                        <Typography variant="body2" noWrap={true}>Tutup</Typography>
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Dialog
                open={tampil_dialog_hapus}
                onClose={() => setTampilDialogHapus(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Konfirmasi Hapus Produk
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Apakah anda yakin ingin menghapus data ini?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        loading={proses}
                        onClick={() => setTampilDialogHapus(false)}
                        autoFocus
                    >
                        Tidak
                    </LoadingButton>
                    <LoadingButton
                        loading={proses}
                        onClick={() => {
                            setTampilDialogHapus(false);
                            setTampilDialog(false);
                            hapus();
                        }}
                    >
                        Ya
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default forwardRef(Anggota);